module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTGEO-75Bold.6ab1db40.otf";